import { useTranslation } from "react-i18next";

export default function CTASection() {
  const { t } = useTranslation();

  return (
    <section id="cta" className="w-full bg-white py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
          {/* Left: Info */}
          <div>
            <p className="text-[#BF9B5E] text-xs font-semibold tracking-[0.3em] uppercase mb-4">
              {t("cta_label")}
            </p>
            <h2 className="text-[#1a1a1a] text-4xl md:text-5xl font-bold leading-tight mb-6">
              {t("cta_title")}
            </h2>
            <p className="text-gray-600 text-base leading-relaxed mb-6">
              {t("cta_text")}
            </p>

            <div className="bg-[#f8f6f2] border-l-4 border-[#BF9B5E] p-6 mb-10">
              <p className="text-[#1a1a1a] text-lg font-medium leading-relaxed">
                {t("cta_subtitle")}
              </p>
            </div>

            <div className="space-y-4">
              <div className="flex items-start gap-4">
                <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                  <i className="ri-check-line text-[#BF9B5E] text-xl" />
                </div>
                <p className="text-gray-600 text-sm leading-relaxed pt-1">{t("value_item1_title")}</p>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                  <i className="ri-check-line text-[#BF9B5E] text-xl" />
                </div>
                <p className="text-gray-600 text-sm leading-relaxed pt-1">{t("value_item2_title")}</p>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                  <i className="ri-check-line text-[#BF9B5E] text-xl" />
                </div>
                <p className="text-gray-600 text-sm leading-relaxed pt-1">{t("value_item3_title")}</p>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                  <i className="ri-check-line text-[#BF9B5E] text-xl" />
                </div>
                <p className="text-gray-600 text-sm leading-relaxed pt-1">{t("value_item4_title")}</p>
              </div>
            </div>
          </div>

          {/* Right: Registration Link */}
          <div className="bg-[#f8f6f2] p-8 md:p-10 flex flex-col items-center justify-center text-center min-h-[320px]">
            <div className="w-16 h-16 flex items-center justify-center bg-[#BF9B5E] rounded-full mb-6">
              <i className="ri-user-add-line text-white text-2xl" />
            </div>
            <p className="text-[#1a1a1a] text-xl font-semibold mb-3">
              {t("cta_title")}
            </p>
            <p className="text-gray-500 text-sm leading-relaxed mb-8 max-w-xs">
              {t("cta_form_link_desc")}
            </p>
            <a
              href="https://forms.office.com/r/E37qru48jw"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block w-full max-w-xs py-4 bg-[#1a1a1a] text-white text-sm font-semibold tracking-widest uppercase hover:bg-[#BF9B5E] transition-colors cursor-pointer whitespace-nowrap text-center"
            >
              {t("cta_form_submit")}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
